import { Component, OnInit } from "@angular/core";
import { incidenciaDetalleQABean } from "src/app/shared/model/incidencias/incidenciaDetalleQABean.model";
import { Incidencias } from "src/app/shared/model/incidencias/incidencia.model";
import { Proyectos } from "src/app/shared/model/incidencias/proyectos.model";
import { Router } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { EvidenciaBean } from "src/app/shared/model/incidencias/evidenciaBean.model";
import { Constantes } from "src/app/utilerias/constantes/constantes";
import { DetIncBotones } from "src/app/shared/model/incidencias/detIncBotones.model";
import { ComentariosComponent } from "./comentarios/comentarios.component";
import swal from "sweetalert2";
import { MensajesFijosEnum } from "src/app/utilerias/enums/mensajes-fijos-enum";
import { EmpleadoService } from "src/app/empleado/empleado.service";
import { Area } from "src/app/shared/model/empleado/area.model";
import { Puesto } from "src/app/shared/model/empleado/puesto.model";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { NgIf, NgFor } from "@angular/common";
import {
  FormGroup,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ReasignarResponsableComponent } from "./reasignar-responsable/reasignar-responsable.component";
import {
  ContextoDetalle,
  DetalleIncidenciaBase,
} from "../detalles-comun/detalle-incidencia-base";
import {
  buscaVersion,
  equipoConPuesto,
  nombreDeIntegrante,
} from "../etapa-incidencia.util";
import {
  esCentinela,
  NOMBRE_PENDIENTE,
  rechazoDelGuardado,
  versionParaMovimiento,
} from "../resolucion-version.util";
/** Detalle de incidencia de QA; pinta la plantilla compartida con el detalle de Desarrollo. */
@Component({
  selector: "app-detallesincidencia",
  standalone: true,
  templateUrl: "../detallesIncidenciaDesarrollo/detallesIncidenciaDesarrollo.component.html",
  styleUrls: [
    "./detallesincidencia.component.css",
    "../detalles-comun/resolucion-version.css",
  ],
  imports: [
    MatIcon,
    NgIf,
    NgFor,
    MatButton,
    ReactiveFormsModule,
  ],
})
export class DetallesincidenciaComponent extends DetalleIncidenciaBase implements OnInit {
  detalleIncidencia = new incidenciaDetalleQABean();
  detalleProyecto = new Proyectos();
  cidencia: Incidencias;
  beanproyectos = new Proyectos();
  listaproyectos: Array<Proyectos>;
  listaEvidencias: EvidenciaBean[];

  image: any;
  img: any;

  formDetalle: FormGroup;

  nombreImagenEvidenica: string;
  /** La versión con la que viajan los movimientos; nunca el centinela de T3b. */
  version: string | null = null;
  /** El último movimiento trae el centinela: la resolución espera versión. */
  private filaPendiente = false;

  estatusLiderDev: Boolean = false;
  estatusDev: Boolean = false;
  selectedEmpleado: number;
  motivo: string = "";
  tituloVersionComentario = "";
  protected readonly muestraCausaOrigen = false;
  protected readonly comentarioConDesarrollador = false;

  constructor(
    private readonly sanitizer: DomSanitizer,
    private readonly empleadoService: EmpleadoService,
    private readonly router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.step = 0;
    this.cargaNombreUsuarioLogeado();
    // Los formularios van antes que los datos: con un enlace directo llegan después.
    this.formDetalle = new FormGroup({
      descincidencia: new FormControl(""),
      motivo: new FormControl(this.motivo),
      selectedEmpleado: new FormControl(this.selectedEmpleado),
    });

    this.formComentario = new FormGroup({
      descripcion: new FormControl("", [Validators.required]),
    });

    const state = history.state;
    if (state?.incidencia && state?.proyecto) {
      this.inicializa(state);
      return;
    }

    // Enlace directo: sin el estado del tablero se consulta por el :id de la ruta.
    void this.cargaPorEnlace(
      (contexto) => this.inicializa(contexto),
      () => this.regresar()
    );
  }

  private inicializa(contexto: ContextoDetalle) {
    this.detallemodal = contexto.incidencia;
    this.asignaProyecto(contexto.proyecto);
    this.cambiaColorStatus(this.detallemodal.estatus);
    this.nombreProyecto = contexto.proyecto?.nombre;
    this.formDetalle.patchValue({
      descincidencia: this.detallemodal.descincidencia,
    });
    this.actualizaVersiones();
    this.consultaNombreEmpleado(this.detallemodal);
    this.consultaNombreAsignado(this.detallemodal);

    this.muestraBotones(this.detallemodal.estatus);
    this.getDetalleIncidencia();
    this.consultaAreaPuestoEmpleado();
    // Sólo marca: desde ngOnInit (estado del tablero) no se pinta a mitad del ciclo.
    this.cdr.markForCheck();
  }

  consultaAreaPuestoEmpleado() {
    this.empleadoService.consultaAreaPuestoEmpleado().subscribe((emp) => {
      if (emp?.area) {
        this.validaArea(emp.area, emp.puesto);
      } else {
        this.cdr.detectChanges();
      }
    });
  }
  //TODO:QUEDA PENDIENDTE REVISAR COMO ES EL FLUJO DE AREA DE DESARROLLO Y DEMÁS ETAPAS.
  validaArea(area: Area, puesto: Puesto) {
    switch (area.area) {
      case "Desarrollo":
        break;
      case "Pruebas":
        if (puesto?.puesto === "Lider") {
          this.estatusLiderDev = true;
          // Los testers de la etapa, del proyecto (ver etapa-incidencia.util).
          this.listaEmpleados = equipoConPuesto(
            this.proyecto,
            this.detallemodal.id_etapa,
            "Tester"
          );
          this.cdr.detectChanges();
        } else if (puesto?.puesto === "Tester") {
          this.estatusDev = true;
          this.cdr.detectChanges();
        }
        break;
    }
  }

  procesaNombre(id: number): string {
    return nombreDeIntegrante(this.listaEmpleados, id) ?? "Sin nombre";
  }

  guardaAsignado(selectedEmpleado?: number, motivo?: string) {
    this.selectedEmpleado = Number(
      selectedEmpleado ?? this.formDetalle.get("selectedEmpleado")?.value ?? 0
    );
    this.motivo = String(
      motivo ?? this.formDetalle.get("motivo")?.value ?? ""
    ).trim();

    if (!this.selectedEmpleado || !this.motivo) {
      return;
    }

    const empleado = this.listaEmpleados.find(
      (ab) => ab.usuario.id === this.selectedEmpleado
    )?.persona.nombreCompleto;

    if (!empleado) {
      return;
    }

    // Se manda una copia: si el servidor rechaza el movimiento, la ficha no
    // queda con un estatus que no se guardó.
    const cambio = this.cambioDeTester(this.selectedEmpleado);
    this.incidenciasService.guardaComentario(cambio).subscribe((incidencia) => {
      // Un rechazo (VAL-*) o una respuesta vacía no se pintan como éxito.
      const rechazo = rechazoDelGuardado(incidencia);
      if (rechazo) {
        this.avisaRechazo(rechazo);
        return;
      }
      this.detallemodal.id_usuario_qa = cambio.id_usuario_qa;
      swal
        .fire({
          text: MensajesFijosEnum.INCIDENCIA_EXITOSA,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          icon: "success",
        })
        .then(() => {
          this.actualiza(incidencia);
        });
    });
  }

  /**
   * La reasignación del tester. En RESUELTO pasa a REVISION, salvo mientras
   * la resolución espera versión (T3b, plan §5.6): entonces se queda en
   * RESUELTO, y el servidor la toma como reasignación (mismo estatus, sin
   * comentario y con a quién reasignar) y pone la versión de la fila.
   */
  private cambioDeTester(tester: number): Incidencias {
    if (this.detallemodal.estatus !== Constantes.RESUELTO) {
      this.detalleIncidencia.id_emp_asignado = this.detallemodal.id_usuario_qa;
    }
    this.detalleIncidencia.id_emp_reasignado = tester;
    const enRevision =
      this.detallemodal.estatus === Constantes.RESUELTO && !this.resolucionPendiente;
    return {
      ...this.detallemodal,
      descincidencia: this.motivo,
      detalleBean: this.detalleIncidencia,
      id_version_incidencia: this.detallemodal.version,
      id_usuario_qa: tester,
      estatus: enRevision ? Constantes.REVISION : this.detallemodal.estatus,
      esComentario: this.resolucionPendiente ? Constantes.CERO : this.detallemodal.esComentario,
    };
  }

  actualiza(incidencia: Incidencias) {
    this.detallemodal.estatus = incidencia.estatusPrevio;
    this.cambiaColorStatus(incidencia.estatusPrevio);
    this.muestraBotones(incidencia.estatusPrevio);
    this.detallemodal.id = incidencia.id;
    this.getDetalleIncidencia();

    this.selectedEmpleado = null;
    this.motivo = "";
    this.formDetalle.patchValue({
      motivo: "",
      selectedEmpleado: null,
    });
  }

  onCloseClick() {
    this.regresar();
  }

  abrirReasignacion() {
    const dialogRef = this.dialog.open(ReasignarResponsableComponent, {
      width: "auto",
      maxWidth: "96vw",
      maxHeight: "92vh",
      panelClass: "custom-modalbox",
      data: {
        listaEmpleados: this.listaEmpleados,
        selectedEmpleado: this.selectedEmpleado,
        motivo: this.motivo,
        ...this.reasignacionPendiente(),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }

      this.formDetalle.patchValue({
        selectedEmpleado: result.selectedEmpleado,
        motivo: result.motivo,
      });
      this.guardaAsignado(result.selectedEmpleado, result.motivo);
    });
  }

  /**
   * Mientras la resolución espera versión, la reasignación deja la incidencia
   * en RESUELTO y el diálogo lo dice (maqueta Q1); si no, el diálogo de
   * siempre.
   */
  private reasignacionPendiente(): Record<string, string> {
    if (!this.resolucionPendiente || this.detallemodal.estatus !== Constantes.RESUELTO) {
      return {};
    }
    return {
      titulo: "Reasignar tester",
      roleLabel: "un tester",
      avisoTitulo: "La incidencia se queda en RESUELTO.",
      aviso: `Su resolución está pendiente de versión: el nuevo tester podrá enviarla a revisión cuando la corrección llegue en ${this.proximaVersion}.`,
    };
  }

  regresar() {
    this.router.navigate(["/INCIDENCIAS/INC_QA"]);
  }

  muestraBotones(estatus: String) {
    this.botones.length = 0;
    const estatusNormalizado = String(estatus || this.detallemodal.estatus || "")
      .trim()
      .toUpperCase();

    switch (estatusNormalizado) {
      case Constantes.ABIERTO: {
        this.botones.push(new DetIncBotones("Agregar comentario", "message"));
        this.botones.push(new DetIncBotones("Cancelar", "clear"));
        break;
      }
      case Constantes.OBSERVACIONES: {
        this.botones.push(new DetIncBotones("Agregar comentario", "message"));
        this.botones.push(new DetIncBotones("Cancelar", "clear"));
        break;
      }
      case Constantes.PROCESO: {
        this.botones.push(new DetIncBotones("Agregar comentario", "message"));
        this.botones.push(new DetIncBotones("Cancelar", "clear"));
        break;
      }
      case Constantes.RESUELTO: {
        this.botones.push(new DetIncBotones("Agregar comentario", "message"));
        this.botones.push(new DetIncBotones("En Revision", "rate_review"));
        this.botones.push(new DetIncBotones("Cancelar", "clear"));
        break;
      }
      case Constantes.REVISION: {
        this.botones.push(new DetIncBotones("Agregar comentario", "message"));
        this.botones.push(new DetIncBotones("VoBo", "done_all"));
        this.botones.push(new DetIncBotones("Observacion", "loop"));
        this.botones.push(new DetIncBotones("Cancelar", "clear"));
        break;
      }
      case Constantes.VOBO:
      case Constantes.CANCELADO:
      default: {
        break;
      }
    }
  }

  getDetalleIncidencia() {
    // T3b: con cada lectura del historial, también el estado de la resolución.
    this.consultaEstadoResolucion();
    this.incidenciasService
      .detalleIncidencia(this.detallemodal)
      .subscribe((res) => {
        this.separaDetalles(res);

        // Sin movimientos no hay versión del último: antes tronaba en listadetalles[0].
        if (this.listadetalles.length > 0) {
          this.detalleIncidencia = this.listadetalles[0];
          const idVersion =
            this.detallemodal.estatus === Constantes.RESUELTO
              ? this.detalleIncidencia.id_version_resuelto
              : this.detalleIncidencia.id_version_incidencia;
          // El centinela de T3b nunca viaja: va la detectada y el servidor pone la versión viva.
          this.filaPendiente = esCentinela(idVersion);
          this.version = versionParaMovimiento(idVersion, this.detallemodal.version);
        }
        this.consultaVersionComentario();
        this.actualizaVersiones();
        this.actualizaEvidenciasGenerales();

        this.totalHistorial = this.listaHistorial.length;
        if (this.number(this.detallemodal.esComentario)) {
          this.eliminaNotificacion(this.detallemodal.idNotificacionUsuario);
        }
        this.cdr.detectChanges();
      });
  }

  /**
   * Nombre de la versión del último movimiento, de la etapa del proyecto:
   * consultaVersion.do espera un número y no resuelve los ids de Mongo.
   */
  consultaVersionComentario() {
    this.tituloVersionComentario = this.filaPendiente
      ? NOMBRE_PENDIENTE
      : buscaVersion(this.proyecto, this.detallemodal.id_etapa, this.version)?.nombre || "";
  }

  agregaComentario(titulo: string) {
    let dialogRef = this.dialog.open(ComentariosComponent, {
      width: "auto",
      maxWidth: "96vw",
      maxHeight: "92vh",
      panelClass: "custom-modalbox",
      data: {
        dataKey: this.detallemodal,
        data: this.detalleProyecto,
        version: this.version,
        nombreVersion: this.tituloVersionComentario,
        titulo: titulo,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // Cerrado sin guardar: no hay nada que actualizar (antes tronaba en result.estatusPrevio).
      if (!result) {
        return;
      }
      this.detallemodal.estatus = result.estatusPrevio;
      this.cambiaColorStatus(result.estatusPrevio);
      this.muestraBotones(result.estatusPrevio);
      this.detallemodal.id = result.id;
      this.getDetalleIncidencia();
    });
  }

  fileUrl: any;

  cambiaColorStatus(estatus) {
    switch (estatus) {
      case Constantes.ABIERTO: {
        this.detallemodal.colorEstatus = Constantes.ABIERTOCOLOR;
        break;
      }
      case Constantes.OBSERVACIONES: {
        this.detallemodal.colorEstatus = Constantes.OBSERVACIONESCOLOR;
        break;
      }
      case Constantes.PROCESO: {
        this.detallemodal.colorEstatus = Constantes.PROCESOCOLOR;
        break;
      }
      case Constantes.RESUELTO: {
        this.detallemodal.colorEstatus = Constantes.RESUELTOCOLOR;
        break;
      }
      case Constantes.REVISION: {
        this.detallemodal.colorEstatus = Constantes.REVISIONCOLOR;
        break;
      }
      case Constantes.VOBO: {
        this.detallemodal.colorEstatus = Constantes.VOBOCOLOR;
        break;
      }
      case Constantes.CANCELADO: {
        this.detallemodal.colorEstatus = Constantes.CANCELADOCOLOR;
        break;
      }
      default: {
        this.detallemodal.colorEstatus = Constantes.CANCELADOCOLOR;
        break;
      }
    }
  }

  getActionLabel(titulo: string): string {
    switch (titulo) {
      case "Agregar comentario":
        return "Comentar";
      case "En Revision":
        return "Enviar a revisión";
      case "VoBo":
        return "Aprobar";
      case "Observacion":
        return "Marcar observación";
      case "Cancelar":
        return "Cerrar ticket";
      default:
        return titulo;
    }
  }

  getActionTone(titulo: string): string {
    switch (titulo) {
      case "Cancelar":
        return "warn";
      case "VoBo":
      case "En Revision":
        return "primary";
      default:
        return "neutral";
    }
  }

  stringify(value: any): string {
    return String(value);
  }

  openCommentComposer() {
    if (this.canShowCommentComposer()) {
      this.agregaComentario(this.commentActionTitle);
    }
  }

  hasAssignmentTools(): boolean {
    return !this.estatusDev;
  }

  /** Color de la página: el del estatus o, mientras no tenga, el naranja de siempre. */
  get statusColor() {
    return this.detallemodal.colorEstatus || "#f25c05";
  }

  /** En QA el chip de estatus lleva su propio color en cuanto la incidencia tiene uno. */
  get colorEstatusChip() {
    return this.detallemodal.colorEstatus;
  }

  protected refreshView(): void {
    this.cdr.detectChanges();
  }

  protected resolveVersionId(): any {
    return this.version;
  }

  protected avisaFalloDeCarga(error: unknown): void {
    console.error("Upload error: ", error);
  }

  protected actualizaTrasComentario(incidencia: Incidencias): void {
    this.detallemodal.estatus = incidencia.estatusPrevio;
    this.cambiaColorStatus(incidencia.estatusPrevio);
    this.muestraBotones(incidencia.estatusPrevio);
    this.detallemodal.id = incidencia.id;
    this.formComentario.reset();
    this.evidenciaComentario = [];
    this.getDetalleIncidencia();
  }
}
